import { createAction, props } from '@ngrx/store'
import { FeedbackModel, RequestModel } from '@models/index'

export const searchFeedbacksByLocation = createAction(
    '[Feedbacks Page] Search Feedbacks By Location',
    props<{ request: RequestModel }>()
)

export const getTotalFeedbacksByLocation = createAction(
    '[Feedbacks Page] Get Total Feedbacks By Location',
    props<{ request: RequestModel }>()
)

export const getTotalFeedbacksByLocationSuccess = createAction(
    '[Feedbacks Page] Get Total Feedbacks By Location Success',
    props<{ total: number }>()
)

export const filterFeedbacksByLocation = createAction(
    '[Feedbacks Page] Filter Feedbacks By Location',
    props<{ request: RequestModel }>()
)

export const searchFeedbacksSuccess = createAction(
    '[Feedbacks Page] Search Feedbacks Success',
    props<{ total: number, data: FeedbackModel[] }>()
)

export const feedbackError = createAction(
    '[Feedbacks Page] Feedback Error',    
    props<{ error: string }>()
)